module.exports = __webpack_public_path__ + "assets/zoominfo.414a7a58.svg";